import { isBrowser } from '../shared/common';
import Event from '../shared/Event';
import WindowScroll, { ScrollPosition } from './WindowScroll';

export default class WindowScrollObserver {
  public static onScrollChange: Event<ScrollPosition> = new Event();

  private static isInitialized = false;

  public static initialize() {
    if (!WindowScrollObserver.isInitialized && isBrowser()) {
      window.addEventListener('scroll', () => {
        WindowScrollObserver.onScrollChange.raise(WindowScroll.getPosition());
      });

      WindowScrollObserver.isInitialized = true;
    }
  }
}

WindowScrollObserver.initialize();
